import { render, staticRenderFns } from "./LayoutFive.vue?vue&type=template&id=2979dbe9"
import script from "./LayoutFive.vue?vue&type=script&lang=js"
export * from "./LayoutFive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports